import type { ReactElement } from "react";
export type TabType = "details" | "suggested" | "extras";

export interface TabsProps {
  readonly activeTab: TabType;
  readonly onTabChange: (tab: TabType) => void;
}

export function Tabs({ activeTab, onTabChange }: TabsProps): ReactElement {
  const tabs: Array<{ id: TabType; label: string }> = [
    { id: "details", label: "Details" },
    { id: "suggested", label: "Suggested" },
    { id: "extras", label: "Extras" },
  ];

  const handleKeyDown = (e: React.KeyboardEvent) => {
    const currentIndex = tabs.findIndex((t) => t.id === activeTab);
    let newIndex = currentIndex;

    switch (e.key) {
      case "ArrowLeft":
        e.preventDefault();
        newIndex = currentIndex - 1 < 0 ? tabs.length - 1 : currentIndex - 1;
        onTabChange(tabs[newIndex].id);
        break;
      case "ArrowRight":
        e.preventDefault();
        newIndex = (currentIndex + 1) % tabs.length;
        onTabChange(tabs[newIndex].id);
        break;
      case "Home":
        e.preventDefault();
        onTabChange(tabs[0].id);
        break;
      case "End":
        e.preventDefault();
        onTabChange(tabs.at(-1)!.id);
        break;
      // No default
    }
  };

  return (
    <div role="tablist" aria-label="Title information tabs" className="flex gap-4 md:gap-6 lg:gap-8">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          role="tab"
          aria-selected={activeTab === tab.id}
          aria-controls={`${tab.id}-panel`}
          tabIndex={activeTab === tab.id ? 0 : -1}
          onClick={() => onTabChange(tab.id)}
          onKeyDown={handleKeyDown}
          className={`
                        pb-3 md:pb-4 text-sm md:text-base lg:text-lg font-medium transition-colors
                        focus:outline-none
                        ${
                          activeTab === tab.id
                            ? "text-lumi-accent border-b-2 border-lumi-accent"
                            : "text-neutral-400 hover:text-neutral-200"
                        }
                    `}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
}
